import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import {
  commonZH, commonEN, commonJA,
  staticContentZH, staticContentEN, staticContentJA,
  modalZH, modalEN, modalJA,
  dataIOZH, dataIOEN, dataIOJA,
  resourceLimitZH, resourceLimitEN, resourceLimitJA
} from '@redpanda/common-locales';
import { deepMerge, mergeTranslations, createI18nInitConfig } from '@redpanda/utils';

// 本地翻譯檔案
import enTranslation from './locales/en/translation.json';
import zhTranslation from './locales/zh/translation.json';
import jaTranslation from './locales/ja/translation.json';
import enPages from './locales/en/pages.json';
import zhPages from './locales/zh/pages.json';
import jaPages from './locales/ja/pages.json';
import staticContentLocalEN from './locales/en/static-content.json';
import staticContentLocalZH from './locales/zh/static-content.json';
import staticContentLocalJA from './locales/ja/static-content.json';
import enManual from './locales/en/manual.json';
import zhManual from './locales/zh/manual.json';
import jaManual from './locales/ja/manual.json';

const resources = {
  en: {
    translation: mergeTranslations(commonEN, enTranslation),
    pages: enPages,
    manual: enManual,
    staticContent: deepMerge(staticContentEN, staticContentLocalEN),
    modal: modalEN,
    dataIO: dataIOEN,
    resourceLimit: resourceLimitEN,
  },
  zh: {
    translation: mergeTranslations(commonZH, zhTranslation),
    pages: zhPages,
    manual: zhManual,
    staticContent: deepMerge(staticContentZH, staticContentLocalZH),
    modal: modalZH,
    dataIO: dataIOZH,
    resourceLimit: resourceLimitZH,
  },
  ja: {
    translation: mergeTranslations(commonJA, jaTranslation),
    pages: jaPages,
    manual: jaManual,
    staticContent: deepMerge(staticContentJA, staticContentLocalJA),
    modal: modalJA,
    dataIO: dataIOJA,
    resourceLimit: resourceLimitJA,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(createI18nInitConfig({
    resources,
    ns: ['translation', 'pages'],
  }));

export default i18n;
